import { Box, Pagination, Skeleton } from '@mui/material'
import React, { FC } from 'react'

type Props = {
  page: number
  loading: boolean
  totalPage: number
  scrollToTopWhenPageChanged?: boolean
  handlePageChange: (page: number) => void
}

export const ResponsiveApprovedCampaignPagination: FC<Props> = (props) => {
  if (props.loading) {
    return (
      <Box width="100%" height="50px" display="flex" justifyContent="center" alignItems="center">
        <Skeleton width="320px" />
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Pagination
        color="primary"
        count={props.totalPage}
        page={props.page}
        onChange={(_, page) => props.handlePageChange(page)}
      />
    </Box>
  )
}
